import * as React from 'react';

const SvgFolderUpload = props => {
  const { size, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      {...props}
    >
      <path d="M9.5 17.5a8 8 0 018-8 7.86 7.86 0 013.15.66.25.25 0 00.35-.22V4.5A1.5 1.5 0 0019.5 3H9.62a.51.51 0 01-.45-.28L8.22.83A1.49 1.49 0 006.88 0H1.5A1.5 1.5 0 000 1.5v15A1.5 1.5 0 001.5 18h7.56a.45.45 0 00.44-.5z" />
      <path d="M17.5 11a6.5 6.5 0 106.5 6.5 6.51 6.51 0 00-6.5-6.5zm2.39 5.69a.51.51 0 01.06.53.5.5 0 01-.45.28h-.75a.25.25 0 00-.25.25v2.75a1 1 0 01-2 0v-2.75a.25.25 0 00-.25-.25h-.75a.5.5 0 01-.45-.28.51.51 0 01.06-.53l2-2.5a.51.51 0 01.78 0z" />
    </svg>
  );
};

export default SvgFolderUpload;
